import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import CheckIcon from "@mui/icons-material/Check";

const FONT = "'Plus Jakarta Sans', system-ui, -apple-system, sans-serif";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxWidth: "92vw",
  boxSizing: "border-box",
  bgcolor: "background.paper",
  border: 0,
  borderRadius: "18px",
  boxShadow: "0 32px 64px -20px rgba(15,27,42,0.5)",
  p: "28px 24px 22px",
  textAlign: "center",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 1.5,
  outline: "none",
  fontFamily: FONT,
};

export default function SuccessModal({ open, handleClose, msg, nav }) {
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        slotProps={{ backdrop: { sx: { background: "rgba(15,27,42,0.46)" } } }}
      >
        <Box sx={style}>
          <div
            style={{
              background: "#E9F7EE",
              border: "1px solid #C4E8D2",
              borderRadius: "50%",
              width: "64px",
              height: "64px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 4,
            }}
          >
            <div
              style={{
                background: "#2FA864",
                borderRadius: "50%",
                width: "44px",
                height: "44px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CheckIcon
                sx={{ width: "26px", height: "26px", color: "#fff" }}
              />
            </div>
          </div>
          <Typography
            id="modal-modal-title"
            variant="body-title"
            component="h2"
            sx={{ m: 0, fontFamily: FONT, fontSize: 18, fontWeight: 800, letterSpacing: "-0.02em", color: "#0F1B2A" }}
          >
            Success!
          </Typography>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ m: 0, mb: 1, fontFamily: FONT, fontSize: 14, fontWeight: 500, lineHeight: 1.5, color: "#4A5A6E", textWrap: "pretty" }}
          >
            {msg}
          </Typography>
          <Button
            className="btn-contained"
            fullWidth
            onClick={handleClose}
            sx={{
              height: 44,
              margin: "0 !important",
              borderRadius: "10px !important",
              background: "#0B5C8A !important",
              color: "#FFFFFF !important",
              border: "0 !important",
              fontFamily: FONT,
              fontSize: 14,
              fontWeight: 600,
              textTransform: "none",
              boxShadow: "none",
              "&:hover": { background: "#084767 !important" },
            }}
          >
            Go To Dashboard
          </Button>
        </Box>
      </Modal>
    </div>
  );
}
